import { IMAGES } from '../constants/images';

/** Banner image behind each search results page heading */
export const SEARCH_BANNERS = {
  flights: IMAGES.airplane,
  hotels: IMAGES.hotelRoom,
  cars: IMAGES.rentalCar,
  packages: IMAGES.vacationPackage,
  cruises: IMAGES.cruiseShip,
};
